// removed by extract-text-webpack-plugin
module.exports = {"sideBarWidth":"210px"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/index.scss
// module id = yh13
// module chunks = 24